import React from "react";

const Avi = props => (
  <svg viewBox="0 0 46 58" width="1em" height="1em" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M14.191 50.801h3.008l-1.49-4.348zM45.5 39V13.978c0-.766-.092-1.333-.55-1.792L33.313.55A1.891 1.891 0 0 0 31.985 0H2.963C1.777 0 .5.916.5 2.926V39h45zm-14-35.609c0-.458.553-.687.877-.363l10.095 10.095a.513.513 0 0 1-.363.877H31.5V3.391zM17.5 15a1.001 1.001 0 0 1 1.538-.844l11 7a1.003 1.003 0 0 1-.001 1.688l-11 7a1.007 1.007 0 0 1-1.018.033A1.001 1.001 0 0 1 17.5 29V15z" />
      <path d="M.5 41v15c0 1.009 1.22 2 2.463 2h40.074c1.243 0 2.463-.991 2.463-2V41H.5zm17.82 13l-.725-2.092h-3.787L13.07 54h-1.709l3.527-10.063h1.627L20.016 54H18.32zm8.641.055h-2.133l-3.131-10.131h1.873l2.338 8.695 2.475-8.695h1.859l-3.281 10.131zM33.988 54H32.32V43.924h1.668V54z" />
    </g>
  </svg>
);

export default Avi;




// WEBPACK FOOTER //
// src/resources/svg/FileAVI.js